import { createContext, useContext, useEffect, useState } from "react";
import { i18n } from "@/i18n";

const LangContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("qs_lang") || "en");

  useEffect(() => {
    const dir = lang === "he" ? "rtl" : "ltr";
    document.documentElement.setAttribute("dir", dir);
    document.documentElement.setAttribute("lang", lang);
    localStorage.setItem("qs_lang", lang);
  }, [lang]);

  const toggle = () => setLang((l) => (l === "en" ? "he" : "en"));
  const value = { lang, setLang, toggle, t: i18n[lang] };

  return <LangContext.Provider value={value}>{children}</LangContext.Provider>;
}

export const useLang = () => useContext(LangContext);
